import request from '@/router/axios';

export const getList = (current, size, params) => {
  return request({
    url: '/api/blade-loanInformationAuditRecord/loanInformationAuditRecord/list',
    method: 'get',
    params: {
      ...params,
      current,
      size,
    }
  })
}

export const getDetail = (id) => {
  return request({
    url: '/api/blade-loanInformationAuditRecord/loanInformationAuditRecord/detail',
    method: 'get',
    params: {
      id
    }
  })
}

export const remove = (ids) => {
  return request({
    url: '/api/blade-loanInformationAuditRecord/loanInformationAuditRecord/remove',
    method: 'post',
    params: {
      ids,
    }
  })
}

export const add = (row) => {
  return request({
    url: '/api/blade-loanInformationAuditRecord/loanInformationAuditRecord/submit',
    method: 'post',
    data: row
  })
}

export const update = (row) => {
  return request({
    url: '/api/blade-loanInformationAuditRecord/loanInformationAuditRecord/submit',
    method: 'post',
    data: row
  })
}

//timeline-list
export const getTimelineList = (id) => {
  return request({
    url: `/api/blade-loanInformationAuditRecord/loanInformationAuditRecord/timeline-list/${id}`,
    method: 'get',
  })
}
